import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../shared/services/api";
import endPoints from "../../shared/services/endPoints";


export const submitContactForm = createAsyncThunk(

"contact/submitForm",

async (formData,{rejectWithValue}) => {
    try {
        const response = await api("post",endPoints.CREATE_CONTACT,formData);
      if(response.success){
            return response.data
        }
        return rejectWithValue(response.message || `Failed to submit contact form`)
    } catch (error) {
        
       return rejectWithValue(error.response?.data?.message || error.message)
    }
}
);

const contactSlice = createSlice({

    name:'contact',
    initialState:{

        loading:false,
        success:false,
        error:null
    },

    reducers: {
        resetContactState: (state) => {
          state.loading = false;
          state.success = false;
          state.error = null;
        },
      },

      extraReducers:(builder)=>{

        builder
        .addCase(submitContactForm.pending, (state) => {
            state.loading = true;
            state.success = false;
            state.error = null;
          })
          .addCase(submitContactForm.fulfilled, (state) => {
            state.loading = false;
            state.success = true;
          })
          .addCase(submitContactForm.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          });
      }

})


export const { resetContactState } = contactSlice.actions;
export default contactSlice.reducer;
